import { render, staticRenderFns } from "./cop.vue?vue&type=template&id=3899012d&"
import script from "./cop.vue?vue&type=script&lang=js&"
export * from "./cop.vue?vue&type=script&lang=js&"
import style0 from "./cop.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports